import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { CardTokenService, ProviderName, config } from '@fgb/core';
import { TopUpAddressConfig, topUpAddressConfigDefault } from '@fgb/portal-component-library/src/lib/shared/top-up-address';

@Component({
  selector: 'fgbcl-add-payment-card-detail',
  templateUrl: './add-payment-card-detail.component.html',
  styleUrls: ['./add-payment-card-detail.component.scss'],
})
export class AddPaymentCardDetailComponent implements OnInit {
  @Input() formValue: any;
  @Input() closeModal: () => void;
  @Input() provider = ProviderName.FreedomPay;
  @Input() redirectUrl = '/ecash/result';
  @Input() failureUrl = '/ecash/failure';
  @Input() checkoutMode: boolean = false;
  @Input() topUpAddressConfig: TopUpAddressConfig = topUpAddressConfigDefault;
  @Output() closeModalEvent = new EventEmitter();
  @Output() submittedAddressEvent = new EventEmitter();

  memberAddressForm: FormGroup;
  hasSubmittedMemberAddress: boolean = false;
  hasSubmittedMemberAddressFormSuccess: boolean = false;
  totalPrice: number = 0;
  loading: boolean = false;
  config: any = config;

  constructor(private cardTokenService: CardTokenService) {}

  ngOnInit() {
    this.memberAddressForm = this.createInheritedFormGroup(this.formValue);
  }

  private addNewCard(): void {
    this.loading = true;
    this.cardTokenService
      .addNewCardToken(
        this.provider,
        this.config.portalUrl + this.redirectUrl,
        'payment-gateway-area',
        this.config.portalUrl + this.failureUrl
      )
      .then(() => {
        this.loading = false;
      });
  }

  createInheritedFormGroup(originalFormGroup: FormGroup): FormGroup {
    if (!originalFormGroup?.controls) return new FormGroup({});
    const inheritedControls: any = {};
    // Iterate over the original form controls
    Object.keys(originalFormGroup?.controls).forEach((controlName) => {
      const control = originalFormGroup?.get(controlName);
      if (control && control.value) {
        inheritedControls[controlName] = new FormControl(control.value);
      }
    });

    // Add additional controls to the inherited form group
    inheritedControls.FirstName = new FormControl('');
    inheritedControls.LastName = new FormControl('');
    inheritedControls.EmailAddress = new FormControl('');
    return new FormGroup(inheritedControls);
  }

  handleSubmitAddressForm() {
    this.hasSubmittedMemberAddressFormSuccess = true;
    if (!this.checkoutMode) {
      this.addNewCard();
    } else {
      this.submittedAddressEvent.emit();
    }
  }

  close() {
    this.closeModalEvent.emit(true);
  }
}
